import type { ITreePerson } from '../model/ITreePerson'

export function getTreePersonRelationship(
	tp: ITreePerson,
	levelMod = 0,
): string | undefined {
	if (tp.level == null) return undefined
	const level = tp.level + levelMod
	let result: [string | undefined, string | undefined] = [undefined, undefined]
	if (level === 0) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`férj`, `férje`]
					: [`feleség`, `felesége`]
				: [`házastárs`, `házastársa`]
		}
	} else if (level === 1) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`vő`, `veje`]
					: [`meny`, `menye`]
				: [`gyermeke házastársa`, `gyermekének házastársa`]
		} else {
			result = tp.person
				? tp.person.isMale
					? [`fiúgyermek`, `fiúgyermeke`]
					: [`lánygyermek`, `lánygyermeke`]
				: [`gyermeke`, `gyermeke`]
		}
	} else if (level === 2) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`unoka férje`, `unokájának férje`]
					: [`unoka felesége`, `unokájának felesége`]
				: [`unoka házastársa`, `unokájának házastársa`]
		} else {
			result = [`unoka`, `unokája`]
		}
	} else if (level === 3) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`dédunoka férje`, `dédunokájának férje`]
					: [`dédunoka felesége`, `dédunokájának felesége`]
				: [`dédunoka házastársa`, `dédunokájának házastársa`]
		} else {
			result = [`dédunoka`, `dédunokája`]
		}
	} else if (level === 4) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`ükunoka férje`, `ükunokájának férje`]
					: [`ükunoka felesége`, `ükunokájának felesége`]
				: [`ükunoka házastársa`, `ükunokájának házastársa`]
		} else {
			result = [`ükunoka`, `ükunokája`]
		}
	} else if (level === 5) {
		if (tp.coupleWithPrevious) {
			result = tp.person
				? tp.person.isMale
					? [`szépunoka férje`, `szépunokájának férje`]
					: [`szépunoka felesége`, `szépunokájának felesége`]
				: [`szépunoka házastársa`, `szépunokájának házastársa`]
		} else {
			result = [`szépunoka`, `szépunokája`]
		}
	} else if (level > 5) {
		const it = getTreePersonRelationship(tp, levelMod - 5)
		result = [`szépunoka ${it}`, `szépunokájának ${it}`]
	}
	return result[levelMod === 0 ? 0 : 1]
}
